import { motion } from 'framer-motion';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Products } from '../components/Products';
import { Footer } from '../components/Footer';

const HomePage = () => {
  return (
    <div>
      <Hero />
      <About />
      <Products />
      <Footer />
    </div>
  );
};

export default HomePage;
